import React from 'react';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';

interface Props {
  onExecute: () => void;
  /** Marker der Nutzungserfassung (RITA-1504); der Wrapper bildet ihn aus dem Tabellennamen. */
  usageKey?: string;
}

function EditButton({ onExecute, usageKey }: Props) {
  return (
    <IconButton onClick={onExecute} title="Zeile bearbeiten" data-usage={usageKey}>
      <EditIcon />
    </IconButton>
  );
}
export default EditButton;
